import { RSAA } from 'redux-api-middleware';
import { loggedOut, loggedIn } from 'actions/Api'

export const GETPROFILE_REQUEST = '@@api/getProfile/REQUEST'
export const GETPROFILE_SUCCESS = '@@api/getProfile/SUCCESS'
export const GETPROFILE_FAILURE = '@@api/getProfile/FAILURE'

export const SETPROFILE_REQUEST = '@@api/setProfile/REQUEST'
export const SETPROFILE_SUCCESS = '@@api/setProfile/SUCCESS'
export const SETPROFILE_FAILURE = '@@api/setProfile/FAILURE'

export const LINK_CUSTOMER_REQUEST = '@@api/linkCustomer/REQUEST'
export const LINK_CUSTOMER_SUCCESS = '@@api/linkCustomer/SUCCESS'
export const LINK_CUSTOMER_FAILURE = '@@api/linkCustomer/FAILURE'

export const UNLINK_CUSTOMER_REQUEST = '@@api/unlinkCustomer/REQUEST'
export const UNLINK_CUSTOMER_SUCCESS = '@@api/unlinkCustomer/SUCCESS'
export const UNLINK_CUSTOMER_FAILURE = '@@api/unlinkCustomer/FAILURE'

export const LOGIN_REQUEST = '@@api/login/REQUEST'
export const LOGIN_SUCCESS = '@@api/login/SUCCESS'
export const LOGIN_FAILURE = '@@api/login/FAILURE'

export const REGISTER_REQUEST = '@@api/register/REQUEST'
export const REGISTER_SUCCESS = '@@api/register/SUCCESS'
export const REGISTER_FAILURE = '@@api/register/FAILURE'

export const FB_LOGIN_REQUEST = '@@api/facebookLogin/REQUEST'
export const FB_LOGIN_SUCCESS = '@@api/facebookLogin/SUCCESS'
export const FB_LOGIN_FAILURE = '@@api/facebookLogin/FAILURE'

export const CHECK_EMAIL_REQUEST = '@@api/checkEmail/REQUEST'
export const CHECK_EMAIL_SUCCESS = '@@api/checkEmail/SUCCESS'
export const CHECK_EMAIL_FAILURE = '@@api/checkEmail/FAILURE'

export const REQUEST_PIN_REQUEST = '@@api/requestPin/REQUEST'
export const REQUEST_PIN_SUCCESS = '@@api/requestPin/SUCCESS'
export const REQUEST_PIN_FAILURE = '@@api/requestPin/FAILURE'

export const LIST_INVOICES_REQUEST = '@@api/listInvoices/REQUEST'
export const LIST_INVOICES_SUCCESS = '@@api/listInvoices/SUCCESS'
export const LIST_INVOICES_FAILURE = '@@api/listInvoices/FAILURE'

export const COLLECT_INVOICES_REQUEST = '@@api/collectInvoices/REQUEST'
export const COLLECT_INVOICES_SUCCESS = '@@api/collectInvoices/SUCCESS'
export const COLLECT_INVOICES_FAILURE = '@@api/collectInvoices/FAILURE'

export const LIST_SERVICES_REQUEST = '@@api/listServices/REQUEST'
export const LIST_SERVICES_SUCCESS = '@@api/listServices/SUCCESS'
export const LIST_SERVICES_FAILURE = '@@api/listServices/FAILURE'

export const VERIFY_EMAIL_REQUEST = '@@api/verifyEmail/REQUEST'
export const VERIFY_EMAIL_SUCCESS = '@@api/verifyEmail/SUCCESS'
export const VERIFY_EMAIL_FAILURE = '@@api/verifyEmail/FAILURE'

export const ACTIVATE_SPEEDTEST_REQUEST = '@@api/activateSpeedtest/REQUEST'
export const ACTIVATE_SPEEDTEST_SUCCESS = '@@api/activateSpeedtest/SUCCESS'
export const ACTIVATE_SPEEDTEST_FAILURE = '@@api/activateSpeedtest/FAILURE'

export const REQUEST_PASSWORD_RECOVERY_PIN_REQUEST = '@@api/requestPasswordRecoveryPin/REQUEST'
export const REQUEST_PASSWORD_RECOVERY_PIN_SUCCESS = '@@api/requestPasswordRecoveryPin/SUCCESS'
export const REQUEST_PASSWORD_RECOVERY_PIN_FAILURE = '@@api/requestPasswordRecoveryPin/FAILURE'

export const RECOVER_PASSWORD_REQUEST = '@@api/recoverPassword/REQUEST'
export const RECOVER_PASSWORD_SUCCESS = '@@api/recoverPassword/SUCCESS'
export const RECOVER_PASSWORD_FAILURE = '@@api/recoverPassword/FAILURE'

export const DELETE_EMAIL_REQUEST = '@@api/deleteEmail/REQUEST'
export const DELETE_EMAIL_SUCCESS = '@@api/deleteEmail/SUCCESS'
export const DELETE_EMAIL_FAILURE = '@@api/deleteEmail/FAILURE'

export const QUERY_EMAIL_REQUEST = '@@api/queryEmail/REQUEST'
export const QUERY_EMAIL_SUCCESS = '@@api/queryEmail/SUCCESS'
export const QUERY_EMAIL_FAILURE = '@@api/queryEmail/FAILURE'

export const CREATE_EMAIL_REQUEST = '@@api/createEmail/REQUEST'
export const CREATE_EMAIL_SUCCESS = '@@api/createEmail/SUCCESS'
export const CREATE_EMAIL_FAILURE = '@@api/createEmail/FAILURE'

export const MODIFY_EMAIL_REQUEST = '@@api/modifyEmail/REQUEST'
export const MODIFY_EMAIL_SUCCESS = '@@api/modifyEmail/SUCCESS'
export const MODIFY_EMAIL_FAILURE = '@@api/modifyEmail/FAILURE'

export const TOGGLE_FASTPATH_REQUEST = '@@api/toggleFastpath/REQUEST'
export const TOGGLE_FASTPATH_SUCCESS = '@@api/toggleFastpath/SUCCESS'
export const TOGGLE_FASTPATH_FAILURE = '@@api/toggleFastpath/FAILURE'

export const QUERY_FASTPATH_REQUEST = '@@api/queryFastpath/REQUEST'
export const QUERY_FASTPATH_SUCCESS = '@@api/queryFastpath/SUCCESS'
export const QUERY_FASTPATH_FAILURE = '@@api/queryFastpath/FAILURE'

export const SUBSCRIBE_SUPERVECTORING_REQUEST = '@@api/subscribeSupervectoring/REQUEST'
export const SUBSCRIBE_SUPERVECTORING_SUCCESS = '@@api/subscribeSupervectoring/SUCCESS'
export const SUBSCRIBE_SUPERVECTORING_FAILURE = '@@api/subscribeSupervectoring/FAILURE'

export const ORDER_SUPERVECTORING_REQUEST = '@@api/orderSupervectoring/REQUEST'
export const ORDER_SUPERVECTORING_SUCCESS = '@@api/orderSupervectoring/SUCCESS'
export const ORDER_SUPERVECTORING_FAILURE = '@@api/orderSupervectoring/FAILURE'

export const ORDER_SUPERVECTORING_FIBER_REQUEST = '@@api/orderSupervectoringFiber/REQUEST'
export const ORDER_SUPERVECTORING_FIBER_SUCCESS = '@@api/orderSupervectoringFiber/SUCCESS'
export const ORDER_SUPERVECTORING_FIBER_FAILURE = '@@api/orderSupervectoringFiber/FAILURE'

export const SET_IPTV_LICENSES_REQUEST = '@@api/setIptvLicenses/REQUEST'
export const SET_IPTV_LICENSES_SUCCESS = '@@api/setIptvLicenses/SUCCESS'
export const SET_IPTV_LICENSES_FAILURE = '@@api/setIptvLicenses/FAILURE'

export const ADD_IPTV_HARDWARE_REQUEST = '@@api/addIptvHardware/REQUEST'
export const ADD_IPTV_HARDWARE_SUCCESS = '@@api/addIptvHardware/SUCCESS'
export const ADD_IPTV_HARDWARE_FAILURE = '@@api/addIptvHardware/FAILURE'

export const LOAD_SORTED_CHANNELS_REQUEST = '@@api/loadSortedChannels/REQUEST'
export const LOAD_SORTED_CHANNELS_SUCCESS = '@@api/loadSortedChannels/SUCCESS'
export const LOAD_SORTED_CHANNELS_FAILURE = '@@api/loadSortedChannels/FAILURE'

export const SAVE_SORTED_CHANNELS_REQUEST = '@@api/saveSortedChannels/REQUEST'
export const SAVE_SORTED_CHANNELS_SUCCESS = '@@api/saveSortedChannels/SUCCESS'
export const SAVE_SORTED_CHANNELS_FAILURE = '@@api/saveSortedChannels/FAILURE'

export const SEARCH_FAQ_REQUEST = '@@api/searchFaq/REQUEST'
export const SEARCH_FAQ_SUCCESS = '@@api/searchFaq/SUCCESS'
export const SEARCH_FAQ_FAILURE = '@@api/searchFaq/FAILURE'

export const ORDER_FIBER_REQUEST = '@@api/orderFiber/REQUEST'
export const ORDER_FIBER_SUCCESS = '@@api/orderFiber/SUCCESS'
export const ORDER_FIBER_FAILURE = '@@api/orderFiber/FAILURE'

export const listInvoices = (apiUrl,session) => {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/invoice/list?s=' + session,
        method: 'GET',
        types: [
          LIST_INVOICES_REQUEST,
          LIST_INVOICES_SUCCESS,
          LIST_INVOICES_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export const listOpenInvoices = (apiUrl,session) => {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/invoice/list?s=' + session + '&openOnly=1',
        method: 'GET',
        types: [
          LIST_INVOICES_REQUEST,
          LIST_INVOICES_SUCCESS,
          LIST_INVOICES_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export const collectInvoices = (apiUrl,session) => {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/invoice/collect?s=' + session,
        method: 'GET',
        types: [
          COLLECT_INVOICES_REQUEST,
          COLLECT_INVOICES_SUCCESS,
          COLLECT_INVOICES_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export const listServices = (apiUrl,session) => {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/service/list?s=' + session,
        method: 'GET',
        types: [
          LIST_SERVICES_REQUEST,
          LIST_SERVICES_SUCCESS,
          LIST_SERVICES_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export const getProfile = (apiUrl,session) => {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/profile/get?s=' + session,
        method: 'GET',
        types: [
          GETPROFILE_REQUEST,
          GETPROFILE_SUCCESS,
          GETPROFILE_FAILURE
        ]
      }
    });

    console.log('MY: actionResponse = ',actionResponse);

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
    if (!actionResponse.error) {
      dispatch(loggedIn(actionResponse.payload.login, session, null));
      dispatch(listOpenInvoices(apiUrl, session));
    }

  };
}

export function setProfile(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/profile/set?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          SETPROFILE_REQUEST,
          SETPROFILE_SUCCESS,
          SETPROFILE_FAILURE
        ]
      }
    });

    dispatch(getProfile(apiUrl,session));
  };
}

export function linkCustomer(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/customer/link?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          LINK_CUSTOMER_REQUEST,
          LINK_CUSTOMER_SUCCESS,
          LINK_CUSTOMER_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
      dispatch(getProfile(apiUrl,session));
      dispatch(listServices(apiUrl,session));
    }
  };
}

export function unlinkCustomer(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/customer/unlink?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          UNLINK_CUSTOMER_REQUEST,
          UNLINK_CUSTOMER_SUCCESS,
          UNLINK_CUSTOMER_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
      dispatch(getProfile(apiUrl,session));
      dispatch(listServices(apiUrl,session));
    }
  };
}

export function setSession(session) {
    return { type: 'set_session', payload: { session } };
}

export function checkEmail(apiUrl,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/auth/checkEmail',
        method: 'POST',
//        credentials: 'include',
        body: JSON.stringify(payload),
        types: [
          CHECK_EMAIL_REQUEST,
          CHECK_EMAIL_SUCCESS,
          CHECK_EMAIL_FAILURE
        ]
      }
    });
  };
}

export function login(apiUrl,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/auth/login',
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          LOGIN_REQUEST,
          LOGIN_SUCCESS,
          LOGIN_FAILURE
        ]
      }
    });

    if (actionResponse.payload.session) {
      // store the session
      dispatch(setSession(actionResponse.payload.session));

      // after every successful login load the profile  - removed, will be automatically done with setting the session
//      dispatch(getProfile(apiUrl,actionResponse.payload.session));

/*
LogRocket.identify('THE_USER_ID_IN_YOUR_APP', {
  name: 'James Morrison',
  email: 'jamesmorrison@example.com',

  // Add your own custom user variables here, ie:
  subscriptionType: 'pro'
});
*/
    }
  };
}

export function requestPin(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/customer/requestPin?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          REQUEST_PIN_REQUEST,
          REQUEST_PIN_SUCCESS,
          REQUEST_PIN_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.session) {
    }
  };
}

export function requestPasswordRecoveryPin(apiUrl,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/auth/requestPin',
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          REQUEST_PASSWORD_RECOVERY_PIN_REQUEST,
          REQUEST_PASSWORD_RECOVERY_PIN_SUCCESS,
          REQUEST_PASSWORD_RECOVERY_PIN_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.session) {
    }
  };
}

export function recoverPassword(apiUrl,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/auth/recoverPassword',
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          RECOVER_PASSWORD_REQUEST,
          RECOVER_PASSWORD_SUCCESS,
          RECOVER_PASSWORD_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
      // log in the user with the new username and password
      dispatch(login(apiUrl,{ username: payload.username, password: payload.password }));
    }
  };
}

export function register(apiUrl,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/auth/register',
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          REGISTER_REQUEST,
          REGISTER_SUCCESS,
          REGISTER_FAILURE
        ]
      }
    });

    if (actionResponse.payload.session) {
      // store the session
      dispatch(setSession(actionResponse.payload.session));

      // after every successful login load the profile  - removed, will be automatically done with setting the session
//      dispatch(getProfile(apiUrl,actionResponse.payload.session));
    }
  };
}

export function verifyEmail(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/profile/verifyEmail?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          VERIFY_EMAIL_REQUEST,
          VERIFY_EMAIL_SUCCESS,
          VERIFY_EMAIL_FAILURE
        ]
      }
    });

    if (actionResponse.payload.success) {
      dispatch(getProfile(apiUrl,session));
    }
  };
}

export function loginWithFacebook(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/facebook/login?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          FB_LOGIN_REQUEST,
          FB_LOGIN_SUCCESS,
          FB_LOGIN_FAILURE
        ]
      }
    });

    if (actionResponse.payload.session) {
      // store the new session, which will force a getProfile
//      console.log('MY: setting session to ', actionResponse.payload.session);
      dispatch(setSession(actionResponse.payload.session));
    } else {
      // no account with facebook userId found
      window.FB.getLoginStatus(function(response) {
                if (response.status === "connected") {
                    window.FB.logout(function(response) {
                    });
                }
            }, true);

    }
  };
}

export function activateSpeedtest(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/speedtest/activate?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          ACTIVATE_SPEEDTEST_REQUEST,
          ACTIVATE_SPEEDTEST_SUCCESS,
          ACTIVATE_SPEEDTEST_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
//      dispatch(getProfile(apiUrl,session));
      dispatch(listServices(apiUrl,session));
    }
  };
}

export function deleteEmail(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/email/deactivate?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          DELETE_EMAIL_REQUEST,
          DELETE_EMAIL_SUCCESS,
          DELETE_EMAIL_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
      dispatch(listServices(apiUrl,session));
    }
  };
}

export function createEmail(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/email/new?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          CREATE_EMAIL_REQUEST,
          CREATE_EMAIL_SUCCESS,
          CREATE_EMAIL_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
      dispatch(listServices(apiUrl,session));
    }
  };
}

export function modifyEmail(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/email/modify?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          MODIFY_EMAIL_REQUEST,
          MODIFY_EMAIL_SUCCESS,
          MODIFY_EMAIL_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
      dispatch(listServices(apiUrl,session));
    }
  };
}

export function queryEmail(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/email/query?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          QUERY_EMAIL_REQUEST,
          QUERY_EMAIL_SUCCESS,
          QUERY_EMAIL_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
    }
  };
}

export function toggleFastpath(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/service/fastpath?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          TOGGLE_FASTPATH_REQUEST,
          TOGGLE_FASTPATH_SUCCESS,
          TOGGLE_FASTPATH_FAILURE
        ]
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    if (actionResponse.payload.success) {
    }
  };
}

export function queryFastpath(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/service/fastpath?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          QUERY_FASTPATH_REQUEST,
          QUERY_FASTPATH_SUCCESS,
          QUERY_FASTPATH_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export function subscribeSupervectoring(apiUrl,session) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/supervectoring/subscribe?s=' + session,
        method: 'POST',
        body: null,
        types: [
          SUBSCRIBE_SUPERVECTORING_REQUEST,
          SUBSCRIBE_SUPERVECTORING_SUCCESS,
          SUBSCRIBE_SUPERVECTORING_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    dispatch(getProfile(apiUrl,session));
  };
}

export function orderSupervectoring(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/supervectoring/order?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          ORDER_SUPERVECTORING_REQUEST,
          ORDER_SUPERVECTORING_SUCCESS,
          ORDER_SUPERVECTORING_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    dispatch(getProfile(apiUrl,session));
    dispatch(listServices(apiUrl,session));
  };
}

export function orderSupervectoringFiber(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/supervectoring/orderFiber?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          ORDER_SUPERVECTORING_FIBER_REQUEST,
          ORDER_SUPERVECTORING_FIBER_SUCCESS,
          ORDER_SUPERVECTORING_FIBER_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    dispatch(getProfile(apiUrl,session));
    dispatch(listServices(apiUrl,session));
  };
}

export function orderFiber(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/fiber/order?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          ORDER_FIBER_REQUEST,
          ORDER_FIBER_SUCCESS,
          ORDER_FIBER_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    dispatch(getProfile(apiUrl,session));
    dispatch(listServices(apiUrl,session));
  };
}

export function setIptvLicenses(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/apptv/setLicenses?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          SET_IPTV_LICENSES_REQUEST,
          SET_IPTV_LICENSES_SUCCESS,
          SET_IPTV_LICENSES_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    dispatch(getProfile(apiUrl,session));
    dispatch(listServices(apiUrl,session));
  };
}

export function addIptvHardware(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/apptv/addHardware?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          ADD_IPTV_HARDWARE_REQUEST,
          ADD_IPTV_HARDWARE_SUCCESS,
          ADD_IPTV_HARDWARE_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }

    dispatch(getProfile(apiUrl,session));
    dispatch(listServices(apiUrl,session));
  };
}

export function loadSortedChannels(apiUrl,session,sid) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/apptv/listSortedChannels?s=' + session + '&sid=' + sid,
        method: 'GET',
        types: [
          LOAD_SORTED_CHANNELS_REQUEST,
          LOAD_SORTED_CHANNELS_SUCCESS,
          LOAD_SORTED_CHANNELS_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export function saveSortedChannels(apiUrl,session,payload) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: apiUrl + '/apptv/saveSortedChannels?s=' + session,
        method: 'POST',
        body: JSON.stringify(payload),
        types: [
          SAVE_SORTED_CHANNELS_REQUEST,
          SAVE_SORTED_CHANNELS_SUCCESS,
          SAVE_SORTED_CHANNELS_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

export function searchFaq(query) {
  return async(dispatch, getState) => {
    const actionResponse = await dispatch({
      [RSAA]: {
        endpoint: 'https://api.hubspot.com/contentsearch/v2/search?portalId=6186115&type=KNOWLEDGE_ARTICLE&requestSource=LIVE_PAGE&autocomplete=true&limit=5&term=' + query,
        method: 'GET',
        types: [
          SEARCH_FAQ_REQUEST,
          SEARCH_FAQ_SUCCESS,
          SEARCH_FAQ_FAILURE
        ],
        options: {
          timeout: 4000
        }
      }
    });

    if (actionResponse.error && actionResponse.payload.status===401) {
      dispatch(loggedOut());
    }
  };
}

